<script lang="ts">
  import { api } from '$shared/api';

  interface DuelTrophy {
    duel_id: number;
    duel_name: string;
    kind: 'duel_win_curator' | 'duel_win_creator' | 'duel_podium' | string;
    ended_at: string;
  }

  // Public profiles pass the user's id; the account page sets `own` instead
  // (docs/curation-duels.md § Rewards: /users/{id}/trophies is public,
  // /users/current/trophies is the caller's).
  let { userId = null, own = false }: { userId?: number | null; own?: boolean } = $props();

  let trophies = $state<DuelTrophy[]>([]);

  const KIND_META: Record<string, { icon: string; label: string }> = {
    duel_win_curator: { icon: '👑', label: 'Curator Crown' },
    duel_win_creator: { icon: '🎵', label: 'Creator Crown' },
    duel_podium: { icon: '🏅', label: 'Podium' },
  };

  $effect(() => {
    loadTrophies();
  });

  async function loadTrophies() {
    if (!own && !userId) return;
    try {
      const path = own ? '/users/current/trophies' : `/users/${userId}/trophies`;
      trophies = (await api.get<DuelTrophy[]>(path)) ?? [];
    } catch {
      trophies = []; // trophy case is decorative — never break the page
    }
  }
</script>

{#if trophies.length > 0}
  <div class="section">
    <h2>Duel Trophies</h2>
    <div class="duel-trophies">
      {#each trophies as trophy (trophy.duel_id + trophy.kind)}
        <a class="trophy-badge" href="#/duels/{trophy.duel_id}/result">
          {(KIND_META[trophy.kind] ?? { icon: '🏅' }).icon}
          <span class="trophy-duel">{trophy.duel_name}</span>
          <span class="trophy-kind">{(KIND_META[trophy.kind] ?? { label: trophy.kind }).label}</span>
        </a>
      {/each}
    </div>
  </div>
{/if}

<style>
  .section {
    margin-top: 2rem;
  }
  .section h2 {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
  .duel-trophies {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .trophy-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.7rem;
    border: 1px solid var(--border);
    border-radius: 999px;
    background: var(--surface);
    font-size: 0.85rem;
    text-decoration: none;
    color: inherit;
  }
  .trophy-badge:hover {
    border-color: var(--gold, #fbbf24);
  }
  .trophy-duel {
    font-weight: 600;
  }
  .trophy-kind {
    color: var(--text-muted, #9ca3af);
    font-size: 0.78rem;
  }
</style>
